module.exports = __webpack_public_path__ + "img/exportJson1.c2a35e5a.png";